import { VisitType } from "#/decision_tree_viewer/models/visit-type";
import { BaseDecisionTreeViewerApi } from "./base";

class VisitTypeApi extends BaseDecisionTreeViewerApi {
  constructor() {
    super({ model: VisitType, baseURL: "/ehr_visit_types" });
  }
}

let api;

export const createVisitTypeApi = () => {
  api ??= new VisitTypeApi();

  return {
    all: async () => api.get(),
  };
};
